export default __webpack_public_path__ + "static/cancelethereumtransactions-56638d7a4eb3d3718a2b02c76a3f6dfd.jpg";